export default __webpack_public_path__ + "static/media/32_jpeg.aec1b7df.jpg";